<template #default>
    <div>
        <div class="mb-0">
            <h6 class="font-weight-bold text-info mb-3">
                <i class="mdi mdi-information-outline mr-1"></i>
                Basic Information
            </h6>
            <div class="row">
                <div class="col-md-6 mb-3">
                    <small class="text-muted d-block mb-1">Level</small>
                    <b-badge :variant="errorLog.level === 'critical' ? 'danger' : errorLog.level === 'warning' ? 'warning' : errorLog.level === 'error' ? 'info' : 'secondary'">
                        {{ errorLog.level || '--' }}
                    </b-badge>
                </div>
                <div class="col-md-6 mb-3">
                    <small class="text-muted d-block mb-1">Context</small>
                    <b-badge v-if="errorLog.context" :variant="errorLog.context === 'http' ? 'primary' : 'success'">{{ errorLog.context }}</b-badge>
                    <span v-else>--</span>
                </div>
                <div class="col-md-6 mb-3">
                    <small class="text-muted d-block mb-1">Hostname</small>
                    <div class="border rounded bg-light p-2">{{ errorLog.hostname || '--' }}</div>
                </div>
                <div class="col-md-6 mb-3">
                    <small class="text-muted d-block mb-1">{{ $t('label.createdAt') }}</small>
                    <div class="border rounded bg-light p-2">{{ errorLog.createdAt || '--' }}</div>
                </div>
            </div>
        </div>
        <hr>
        <div class="mb-3">
            <h6 class="font-weight-bold text-info mb-3">
                <i class="mdi mdi-alert-circle-outline mr-1"></i>
                Exception
            </h6>
            <div class="row">
                <div class="col-md-6 mb-3">
                    <small class="text-muted d-block mb-1">Exception Class</small>
                    <div class="border rounded bg-light p-2">{{ errorLog.exceptionClass || '--' }}</div>
                </div>
                <div class="col-md-6 mb-3">
                    <small class="text-muted d-block mb-1">Exception Code</small>
                    <div class="border rounded bg-light p-2">{{ errorLog.exceptionCode || '--' }}</div>
                </div>
            </div>
            <div class="mb-3">
                <small class="text-muted d-block mb-1">Message</small>
                <div class="border rounded bg-light p-2 text-primary">{{ errorLog.message || '--' }}</div>
            </div>
            <div>
                <small class="text-muted d-block mb-1">Source</small>
                <div class="border rounded bg-light p-2">
                    <code>
                        {{ errorLog.sourceFile || '--' }}<span v-if="errorLog.sourceLine"> : {{ errorLog.sourceLine }}</span>
                    </code>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <small class="text-muted d-block mb-1">Source Line</small>
                <div class="border rounded bg-light p-2">{{ errorLog.sourceLine || '--' }}</div>
            </div>
        </div>
        <hr>
        <div class="mb-3">
            <h6 class="font-weight-bold text-info mb-3">
                <i class="mdi mdi-speedometer mr-1"></i>
                Performance
            </h6>
            <div
                v-if="errorLog.performance"
                class="table-responsive"
            >
                <table class="table table-sm table-bordered mb-0">
                    <tbody>
                        <tr>
                            <td class="font-weight-bold text-muted text-nowrap">Memory Usage</td>
                            <td>{{ errorLog.performance.memoryUsageMb }}</td>
                        </tr>
                        <tr>
                            <td class="font-weight-bold text-muted text-nowrap">Memory Peak</td>
                            <td>{{ errorLog.performance.memoryPeakMb }}</td>
                        </tr>
                        <tr>
                            <td class="font-weight-bold text-muted text-nowrap">Uptime</td>
                            <td>{{ errorLog.performance.uptimeMs }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <span v-else>--</span>
        </div>
        <hr>
        <div class="mb-4">
            <h6 class="font-weight-bold text-info mb-3">
                <i class="mdi mdi-code-tags mr-1"></i>
                Stack Trace
            </h6>
            <div class="border rounded bg-light p-3 overflow-auto">
                <pre class="mb-0">{{ errorLog.stackTrace || '--' }}</pre>
            </div>
        </div>
        <div>
            <h6 class="font-weight-bold text-info mb-3">
                <i class="mdi mdi-history mr-1"></i>
                Previous Exception
            </h6>
            <div class="border rounded bg-light p-3 overflow-auto">
                <pre class="mb-0">{{ errorLog.previous_exception ? getJsonText(errorLog.previous_exception) : '--' }}</pre>
            </div>
        </div>
        <hr class="my-3 mx-n4">
        <div class="d-flex justify-content-end">
            <b-button
                type="button"
                variant="danger"
                class="col-2"
                @click="$emit('done')"
            >
                {{ $t('label.cancel') }}
            </b-button>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        errorLog: {
            type: Object,
            required: true,
        },
    },
    methods: {
        getJsonText(data) {
            if (typeof data == 'string') return data;
            return JSON.stringify(data, null, 2);
        },
    },
}
</script>